import LaunchDarkly from '@module/launchdarkly';

import {
  EXPERIMENT_COOKIE_BANNER,
  EXPERIMENT_COOKIE_BANNER_COPY,
} from '@app/constant/experiments';

export const isV3Variant = () => {
  const variant = LaunchDarkly.getVariant(EXPERIMENT_COOKIE_BANNER_COPY);

  // Experiment V3
  if (variant === 'A' || variant === 'B' || variant === 'C') {
    return true;
  }

  return false;
};

export const shouldDisplayCookieWall = () => {
  // Experiment V2 + V2.2
  if (LaunchDarkly.getVariant(EXPERIMENT_COOKIE_BANNER)) {
    return true;
  }

  // Experiment V3
  if (isV3Variant()) {
    return true;
  }

  return false;
};
